import { ALL_LNGS_NAMESPACES } from '@ingenico/util-i18n-config';
import { CopyLabelCard } from '@ingenico/react-ui/copy-label-card';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { LogicalDeviceTerminalDetailsCardProps } from './logicalDeviceTerminalDetailsCard.model';
import { getDisplayedConfigurationDetails } from './logicalDeviceTerminalDetailsCard.util';

export function LogicalDeviceTerminalDetailsCard({
  metrics,
  physicalDevice,
  logicalDeviceReference,
  shouldDisplayCustomerLayout,
  shouldDisplayMerchantLayout,
}: LogicalDeviceTerminalDetailsCardProps): ReactNode {
  const { t } = useTranslation([ALL_LNGS_NAMESPACES.LOGICAL_DEVICE]);
  return (
    <CopyLabelCard
      sections={[
        {
          title: t('devicePropertiesSections.deviceDetails'),
          content: getDisplayedConfigurationDetails(
            metrics,
            physicalDevice,
            logicalDeviceReference,
            shouldDisplayCustomerLayout,
            shouldDisplayMerchantLayout,
          ),
        },
      ]}
      striped
    />
  );
}
